import * as signalR from '@microsoft/signalr';

let connection: signalR.HubConnection | null = null;
let startingPromise: Promise<signalR.HubConnection> | null = null;
let subscriberCount = 0;

const getNotificationHubUrl = (): string => {
  const apiBase = process.env.REACT_APP_API_URL || '';
  const defaultHub = apiBase
    ? apiBase.replace(/\/api\/?$/, '') + '/hubs/notifications'
    : '/hubs/notifications';
  return process.env.REACT_APP_NOTIFICATION_HUB_URL || defaultHub;
};

export const notificationSignalrService = {
  connect: async (accessTokenFactory?: () => string | null) => {
    subscriberCount = Math.max(0, subscriberCount) + 1;
    if (connection && connection.state === signalR.HubConnectionState.Connected) {
      return connection;
    }
    if (startingPromise) {
      return startingPromise;
    }

    const hubUrl = getNotificationHubUrl();
    // eslint-disable-next-line no-console
    console.log('Notification SignalR hubUrl:', hubUrl);

    const conn = new signalR.HubConnectionBuilder()
      .withUrl(hubUrl, {
        accessTokenFactory: () => accessTokenFactory?.() || '',
        withCredentials: true,
        transport: signalR.HttpTransportType.WebSockets,
        skipNegotiation: true,
      })
      .withAutomaticReconnect({ nextRetryDelayInMilliseconds: () => 1000 })
      .configureLogging(signalR.LogLevel.Information)
      .build();

    startingPromise = conn
      .start()
      .then(() => {
        connection = conn;
        startingPromise = null;
        return conn;
      })
      .catch(err => {
        startingPromise = null;
        subscriberCount = Math.max(0, subscriberCount - 1);
        throw err;
      });

    return startingPromise;
  },

  on: (eventName: string, callback: (...args: unknown[]) => void) => {
    connection?.on(eventName, callback);
  },

  off: (eventName: string, callback?: (...args: unknown[]) => void) => {
    if (callback) {
      connection?.off(eventName, callback);
    } else {
      connection?.off(eventName);
    }
  },

  disconnect: async () => {
    subscriberCount = Math.max(0, subscriberCount - 1);
    if (subscriberCount > 0) return;

    if (startingPromise) {
      try {
        await startingPromise;
      } catch {
        // ignore
      }
    }
    if (connection) {
      try {
        await connection.stop();
      } finally {
        connection = null;
      }
    }
  },
};
